import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { EventLog } from "@vp/models";
import { API_BASE_URL } from "@vp/shared/tokens";
import { createUrlBuilder } from "@vp/shared/utilities";
import { Observable } from "rxjs";
import { EventLogFilter } from "../models/event-log-filter";

@Injectable({
  providedIn: "root"
})
export class EventLogApiService {
  constructor(
    @Inject(API_BASE_URL) private readonly _apiBaseUrl: string,
    private _http: HttpClient
  ) {}

  public getUserEventLogs = (
    filter: Readonly<Partial<EventLogFilter>>
  ): Observable<EventLog[] | null> => {
    const apiURL = `${this._apiBaseUrl}/eventlog/get-report`;
    const urlBuilder = createUrlBuilder(apiURL, Object.keys(filter));
    const urlWithQueryString = urlBuilder.build({}, filter);

    return this._http.get<EventLog[]>(urlWithQueryString);
  };
}
